import React from 'react';
import PropTypes from 'prop-types';

import './AuthWallPageTemplate.scss';
import PageSection from '../../../../components/Layout/PageSection/PageSection';
import Layout from '../../../../components/Layout/Layout';
import SVGFromCloudinary from '../../../../components/Elements/SVGFromCloudinary/SVGFromCloudinary';
import { PAGE_PROPS as pagePropsPropTypes } from '../../../defaultProps';

export default class AuthWallPageTemplate extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseClassName = 'page-Employer-AuthWall-AuthWallPageTemplate';
    }

    static propTypes = {
        /**
         * Global props from the server
         */
        PAGE_PROPS: pagePropsPropTypes,
        /**
         * additional styling
         */
        className: PropTypes.string,
        /**
         * cloudinary id of the page icon
         */
        pageIconCloudinaryId: PropTypes.string.isRequired,
        /**
         * description of the page
         */
        pageDescription: PropTypes.string.isRequired,
    };

    static propTypes = {
        pageIconCloudinaryId: '',
        pageDescription: '',
        className: '',
    };

    render() {
        const {
            PAGE_PROPS,
            pageIconCloudinaryId,
            pageDescription,
            pageDescriptionVRE,
            className,
            endCandidateDatabaseFlag,
        } = this.props;

        return (
            <div className={`${this.baseClassName} ${className}`}>
                <Layout PAGE_PROPS={PAGE_PROPS}>
                    <PageSection
                        pageLayoutStyle="employer-default-layout"
                        className="full-height"
                    >
                        <div className={`${this.baseClassName}__wrapper`}>
                            <SVGFromCloudinary
                                className={`${this.baseClassName}__wrapper__icon`}
                                alt="security state icon"
                                cloudinaryID={`${pageIconCloudinaryId}`}
                            />

                            {endCandidateDatabaseFlag ? (
                                <p
                                    className={`${this.baseClassName}__wrapper__desc top`}
                                >
                                    {pageDescriptionVRE}
                                </p>
                            ) : null}
                            <p
                                className={`${this.baseClassName}__wrapper__desc`}
                            >
                                {pageDescription}
                            </p>
                        </div>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}
